import currencyTypes from "../actionType/currencyTypes";

const initialState = {
  displayCurrency: null,
  // Cache of direct pair rates: { "INR_USD": 0.012, "INR_EUR": 0.011 }
  exchangeRates: {},
  ratesLoading: false,
  ratesTimestamp: null,
};

export const currencyReducer = (
  state = { ...initialState },
  { type, payload }
) => {
  switch (type) {
    case currencyTypes.SET_DISPLAY_CURRENCY: {
      return { ...state, displayCurrency: payload };
    }
    case currencyTypes.SET_EXCHANGE_RATES: {
      return {
        ...state,
        exchangeRates: { ...state.exchangeRates, [payload.key]: payload.rate },
        ratesTimestamp: Date.now(),
      };
    }
    case currencyTypes.SET_RATES_LOADING: {
      return { ...state, ratesLoading: payload };
    }
    default:
      return state;
  }
};
